/** Representa um cliente participante em uma Central de Compras */
export class ClienteCentralCompraParticipante {
    id: number;
    clientePariticipante: any;
    idPessoa: number;
    codigo: number;
    codigoIntegracaoErp: string;
    tipo: number;
    cnpjCpf: string;
    nome: string;
    nomeFantasia: string;

    // Central de Compras
    idClienteCentralCompra: number;
    percParticipacaoCentralCompra: number;

    constructor(id: number = null, idPessoa: number = null, codigoIntegracaoErp: string = null, cnpjCpf: string = null, nome: string = null, nomeFantasia: string = null) {
        this.id = id;
        this.idPessoa = idPessoa;
        this.codigoIntegracaoErp = codigoIntegracaoErp;
        this.cnpjCpf = cnpjCpf;
        this.nome = nome;
        this.nomeFantasia = nomeFantasia;

        this.clientePariticipante = {
            id,
            idPessoa,
            pessoa: {
                id: idPessoa,
                codigoIntegracaoErp,
                cnpjCpf,
                nome,
                nomeFantasia
            }
        };
    }
}
